function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { radioAnatomy as parts } from "@chakra-ui/anatomy";
import Checkbox from "./checkbox";

var baseStyleControl = props => {
  var {
    control = {}
  } = Checkbox.baseStyle(props);
  return _extends({}, control, {
    borderRadius: "full",
    _checked: _extends({}, control["_checked"], {
      _before: {
        content: "\"\"",
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    })
  });
};

var baseStyle = props => ({
  label: Checkbox.baseStyle(props).label,
  control: baseStyleControl(props)
});

var sizes = {
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3
    },
    label: {
      fontSize: "sm"
    }
  }
};
var defaultProps = {
  size: "md",
  colorScheme: "blue"
};
export default {
  parts: parts.keys,
  baseStyle,
  sizes,
  defaultProps
};
//# sourceMappingURL=radio.js.map